import { useState } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase/config";
import toast from "react-hot-toast";
import EditorialMotif from "./EditorialMotif";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = userCredential.user;

        const userDoc = await getDoc(doc(db, "user1", user.uid));
        if (userDoc.exists() && userDoc.data().deactivated) {
          await auth.signOut();
          toast.error("Your account has been deactivated by administration. Please contact us via email if there's any issue. officialmbums@gmail.com");
          return;
        }

        await setDoc(
          doc(db, "user1", user.uid),
          { lastLogin: serverTimestamp() },
          { merge: true }
        );
      } else {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = userCredential.user;
        await setDoc(doc(db, "user1", user.uid), {
          uid: user.uid,
          email: user.email,
          name: name,
          photoURL: user.photoURL || "#",
          points: 0,
          premium: false,
          status: "Free",
          unlockedAreas: ["", ""],
          unlockedMarkers: [""],
          createdAt: serverTimestamp(),
          lastLogin: serverTimestamp(),
          deactivated: false
        });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4 login-page">
      <div className="access-panel bg-gray-950 border border-gray-800 p-8 w-full max-w-md">
        <EditorialMotif className="access-panel__motif" />
        <div className="access-panel__tape">
          <span>Member access</span>
          <span>Discover differently</span>
        </div>
        <div className="flex justify-center mb-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="" className="h-10 w-auto" />
            <div>
              <span className="block text-2xl font-bold text-white">CROATOAN</span>
              <span className="access-panel__subtitle">The private map for urban discovery</span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <label className="access-field-label">
              <span>Your name</span>
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-green-500"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required={!isLogin}
              />
            </label>
          )}
          
          <label className="access-field-label">
            <span>Email</span>
            <input
              type="email"
              placeholder="Email address"
              className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-green-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="access-field-label">
            <span>Password</span>
            <input
              type="password"
              placeholder="Password"
              className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-green-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            className="classified-primary-button w-full py-3 disabled:opacity-50"
          >
            {loading ? "Please wait..." : isLogin ? "Login" : "Create Account"}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="text-gray-400 hover:text-white text-sm"
          >
            {isLogin
              ? "Don't have an account? Sign up"
              : "Already have an account? Login"}
          </button>
        </div>
      </div>
    </div>
  );
}
